<script>
import BaseVolanInputValidate from './BaseVolanInputValidate';
import PrimeTextarea from 'primevue/textarea';
export default {
  name: 'VolanTextarea',
  components: {PrimeTextarea},
  extends: BaseVolanInputValidate,
  inheritAttrs: false,
};
</script>

<template>
  <div class="volanTextContainer p-fluid mt-2 mb-2 pt-1">
    <label :for="computedId">{{ computedLabel }}</label>
    <PrimeTextarea :id="computedId"
                   v-bind="$attrs"
                   :value="value"
                   :class="{'p-invalid': isValid===false}"
                   :disabled="isDisabled"
                   :readonly="isReadonly"
                   v-on="$listeners"
                   @focus="onInputFocus"
                   @blur="onInputBlur"
    />
    <small v-for="(message, index) of internalErrorMessages"
           :key="index"
           class="p-error block"
    >{{ message }}</small>
    <small v-if="!internalErrorMessages.length"
           class="block"
    >{{ hintComputed }}</small>
  </div>
</template>

<style lang="scss">
.volanTextContainer {
  small {
    min-height: 1.5em;
  }
}
</style>